import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9bea2040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-tools" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "large-text" }, "地图复位", -1))

import { ref, onMounted } from 'vue'
import Bus from '@/config/Bus'
import { useMainStore } from '@/store/main'
import mapService from '@/utils/mapServices.js'
import pinia from '@/store/index'
import { Api } from '@/api/publicApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapTools',
  setup(__props) {

const api = new Api()
const mainStore = useMainStore(pinia)
const overlap = ref(false)
const tilt = ref(false)

const test = () => {
  // console.log(0)
  // const xx = {
  //   id: 'LJHSZ118GKJ1',
  //   category: 'ylz',
  //   jd: 105.978,
  //   wd: 29.224,
  // }
  // Bus.emit('showModal', {
  //   data: xx,
  //   modalType: '测试',
  // })
}

const clickEvent = async (val) => {
  switch (val) {
    case '数字孪生':
      mainStore.changeCustomer(true)
      mainStore.$patch({
        topMenu: 'smart_supervision',
        currentLeftMenu: '',
        leftMenu: {},
      })
      // eslint-disable-next-line no-undef
      ue4('CameraSwitch', {
        Id: 'Gis',
        Type: 1,
      })
      break
    case '水质反演':
      if (mapService.getLayer('UAVPoint')) {
        mapService.removeLayer('UAVPoint')
      } else {
        const poi = []
        const pointData = []
        pointData.push({
          coordinates: [106.04803, 29.41383],
          properties: { id: 2, category: 'wrj', modalType: '无人机巡河' },
        })
        pointData.push({
          coordinates: [106.0627416512523, 29.40369319826789],
          properties: { id: 3, category: 'wrj', modalType: '无人机巡河' },
        })
        poi.push({
          Id: 2,
          Label: '无人机',
          Coordinate: { X: 106.05244, Y: 29.41134, Z: 10 },
          Icon: '转移路线',
          Style: 'Icon',
          EleType: 3,
          Args: JSON.stringify({
            layer: '无人机',
            data: { id: 2, category: 'wrj' },
            modalType: '无人机',
          }),
          Group: '无人机',
          VisibleRange: '0,100000',
          Space: 1,
          Title: 2,
        })
        await mapService.addPointsLayer('UAVPoint', pointData, 'UAV', 0.9, 'center')
      }
      break
    case '三维城市':
      mainStore.changeCustomer(false)
      mapService.flyTo({
        center: [105.89845, 29.34622],
        zoom: 16.5,
        pitch: 48.999999999999986,
      })
      break
    case '水旱灾害防御':
      window.location.href = 'https://183.66.101.109:20010/#/fddDefense/homePage/home'
      break
    case '地图复位':
      mapService.reset()
      break
    default:
      break
  }
}

onMounted(() => {
  setTimeout(() => {
    // eslint-disable-next-line no-undef
    ue4('EnvironmentVersion', {}, (version) => {
      tilt.value = true
    })
  }, 1000)
})

return (_ctx: any,_cache: any) => {
  const _component_n_popover = _resolveComponent("n-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_popover, {
      overlap: overlap.value,
      to: false,
      delay: 0,
      trigger: "hover"
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("span", {
          class: "img-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clickEvent('地图复位')))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["overlap"])
  ]))
}
}

})